import { amountToDisplayValue, Flex, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { ImportedInvoiceReviewFormSchema } from '@features/importedInvoices/types/importedInvoiceReviewFormSchema'

import { useFormContext, useWatch } from '../../../../../../../../hooks/useForm'
import { useImportedInvoiceReviewTotals } from '../../hooks/useImportedInvoiceReviewTotals'
import * as Styled from './styles'

export const ImportedInvoiceReviewTotals = (): ReactElement => {
  const { t } = useTranslation()
  const { control } = useFormContext<ImportedInvoiceReviewFormSchema>()
  const currency = useWatch({ control, name: 'currency' })
  const { totalAmountExclVat, totalAmountInclVat, totalVatAmount } = useImportedInvoiceReviewTotals()

  const totals = [
    { amount: totalAmountExclVat, label: t('imported_invoices.review.form.totals.excl_vat') },
    { amount: totalVatAmount, label: t('imported_invoices.review.form.totals.vat_amount') },
    { amount: totalAmountInclVat, label: t('imported_invoices.review.form.totals.incl_vat') },
  ]

  return (
    <Styled.ImportedInvoiceReviewTotalsWrapper>
      {totals.map(({ amount, label }) => (
        <Flex alignItems="center" flexDirection="column" gap={Spacing.S4} key={label}>
          <Text variant="bodySM">{label}</Text>
          <Flex alignItems="center" gap={Spacing.S4} justifyContent="center">
            <Text variant="bodyMD" weight="medium">
              {amountToDisplayValue(amount)}
            </Text>
            {currency && (
              <Text colorVariant="disable" variant="bodySM">
                {currency}
              </Text>
            )}
          </Flex>
        </Flex>
      ))}
    </Styled.ImportedInvoiceReviewTotalsWrapper>
  )
}
